var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOldWoman(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 55.39388,
    viewBox: "0 0 40 55.39388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fadcbc;}.cls-2{fill:#92d3f5;}.cls-3{fill:#d0cfce;}.cls-4{stroke-linecap:round;}.cls-4,.cls-5{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,55.39388v-4c0-5-5-9-10-9-6,5-12,5-18,0-5,0-10,4-10,9v4H39Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26,36.59388c8-6,9-7.2,9-14.2s-2.5-12-5.5-13c0,0-1-1-3.1-1.9-1.5-.6,.7-7.6-5.9-7.1-8.2,.6-4.7,6.2-6.4,6.6-3.9,.9-6.2,2.9-7.6,6.4-1.2,2.9-1.2,7.1-2,11-1,5,4.4,7.4,11.4,13.4l10.1-1.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,25.39388c0,8,4,14,10.9,14,7.1,0,11.1-6,11.1-14,0-5-1.4-7.7-2-9-1-2-2-3-2-3-5,3-14,0-15,1s-3,5-3,11Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1,54.39388v-3c0-5,5-9,10-9,6,5,12,5,18,0,5,0,10,4,10,9v3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22,32.39388c-1.2,.8-2.6,.8-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15,30.39388c0,1-1,2-1,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,30.39388c0,1,1,2,1,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,23.39388c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,23.39388c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9,25.39388c0,8,4,14,10.9,14,7.1,0,11.1-6,11.1-14,0-5-1.4-7.7-2-9-1-2-2-3-2-3-5,3-14,0-15,1s-3,5-3,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10,32.39388c-2,0-5-3-5-8,0-4,0-6,1-9,1.8-5.5,6-9,14-9,6,0,9,3,9,3,3,1,6,4.9,6,12,0,7-2,12-5,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26,7.39388c1-2,0-4-1-5C23,.39388,16.7,.39388,14.7,3.39388c-.8,1.2-.7,2.3-.4,3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldWoman);
export default __webpack_public_path__ + "static/media/old-woman.1a61129ef4e1808777dd5e7536f69965.svg";
export { ForwardRef as ReactComponent };